import loadConfigFromMeta from "@embroider/config-meta-loader"

// Loads the config returned in config/environment.js (which is run in Vite's process, not the browser).
const config = loadConfigFromMeta("cc-frontend") as unknown

export default config as {
  environment: string
  // Ember default properties.
  modulePrefix: string
  podModulePrefix?: string
  locationType: string
  rootURL: string
  APP: Record<string, unknown>
  // Our env vars, declared for the sake of TS files that read them.
  API_ROOT: string
  CLIENT_VERSION: string
  SENTRY_DSN_PUBLIC: string
  BLANK_TEMPLATE_ID: string
  CC_TEMPLATE_GROUP_ID: string
  CC_TEMPLATE_GROUP_ID_1: string
  CC_TEMPLATE_GROUP_ID_2: string
  CC_TEMPLATE_GROUP_ID_3: string
  SOCKET_URL: string
  STRIPE_PK: string
  GOOGLE_API_CONSOLE_KEY: string
  GOOGLE_DEVELOPERS_CLIENT_ID: string
  UNSPLASH_ACCESS_KEY: string
  AMPLITUDE_API_KEY?: string
}
